/**
 * HelpScout Beacon loader.
 *
 * This was previously a minified vendor IIFE pasted inline four times (twice
 * each in Order and Status), re-running whenever the order object changed.
 * Here it is written out once and the script tag is only injected once.
 */

const BEACON_SRC = "https://beacon-v2.helpscout.net";

export const BEACON_IDS = {
  mashAndGrape: "4f9c09da-d0f6-484f-afa5-5f7dca62487a",
  flaviar: "df8f06ef-def1-4fa6-be73-cb482eb78839",
};

/** Queue calls until the real Beacon script replaces this shim. */
function installBeaconShim() {
  if (window.Beacon) return;

  const beacon = (method, options, data) => {
    beacon.readyQueue.push({ method, options, data });
  };
  beacon.readyQueue = [];
  window.Beacon = beacon;
}

function injectBeaconScript() {
  if (document.querySelector(`script[src="${BEACON_SRC}"]`)) return;

  const script = document.createElement("script");
  script.type = "text/javascript";
  script.async = true;
  script.src = BEACON_SRC;
  document.head.appendChild(script);
}

/**
 * Initialise the Beacon widget for a given inbox.
 *
 * @param {string} beaconId - one of BEACON_IDS
 */
export function initHelpScout(beaconId) {
  if (!beaconId) return;

  installBeaconShim();

  if (document.readyState === "complete") {
    injectBeaconScript();
  } else {
    window.addEventListener("load", injectBeaconScript, { once: true });
  }

  window.Beacon("init", beaconId);
}

/**
 * Mash & Grape orders (store 1) outside the Flaviar channel get the Mash &
 * Grape inbox; everything else goes to Flaviar support.
 */
export function beaconIdForOrder(order) {
  return order?.store_id === 1 && order?.channel_id !== 40
    ? BEACON_IDS.mashAndGrape
    : BEACON_IDS.flaviar;
}
